// Module
var code = "<ul class=\"bar-chart-with-labels\"> <li> <svg ref=\"svgElement\" role=\"graphics-document document\" width=\"100%\"></svg> </li> </ul> ";
// Exports
export default code;